import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import useNotification from '../../../hooks/useNotification';
import useAxios from '../../../hooks/useAxios';
import { useEffect, useState } from 'react';
import { getPtStatsByStudentsDetail } from '../../../api/statistics.api';
import moment from 'moment';
import Loader from '../../../components/Loader';
import Button from '../../../components/Button';
import SelectCampus from '../../../components/SelectCampus';
import SelectEduStep from '../../../components/SelectEduStep';
import ErrorResponse from '../../../components/ErrorResponse';
import DownloadButton from '../../../components/DownloadButton';
import { DatePicker, Table, TableColumnsType } from 'antd';
import {
  IPtStatsByStudentsDetailReq,
  IPtStatsByStudentsDetail,
  IGetPtStatsByStudentsDetail,
} from '../../../models/statistics.model';
import Pagination from '../../../components/Pagination';
import { getCommonCodeLabel } from '../../../lib/store';
import PtStatsByNotesModal from './PtStatsByNotesModal';
import exportTable from '../../../lib/exportTable';

const PtStatsByStudentsDetail = () => {
  const { t, i18n } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { infoNotification } = useNotification();

  const [eduStepCode, setEduStepCode] = useState('EM');
  const [linkEduStepCode, setLinkEduStepCode] = useState('EM');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [speakingModalVisible, setSpeakingModalVisible] = useState(false);
  const [excelCampus, setExcelCampus] = useState('');

  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetPtStatsByStudentsDetail>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetPtStatsByStudentsDetail>();
  const [data, setData] = useState<IPtStatsByStudentsDetail[]>([]);
  const [pageNo, setPageNo] = useState(1);
  const pageSize = 50;

  const onSearch = () => {
    if (!startDate) {
      return infoNotification(t('statistics.placementTest.message2'));
    }
    if (!endDate) {
      return infoNotification(t('statistics.placementTest.message3'));
    }

    getStudentsStat();
  };

  const onSpeakingNote = () => {
    setSpeakingModalVisible(true);
  };

  useEffect(() => {
    setStartDate(moment().add(-1, 'months').format('YYYYMMDD'));
    setEndDate(moment().format('YYYYMMDD'));
  }, []);

  useEffect(() => {
    if (res && !isLoading) {
      // data filtering
      setData(res?.data);
    }
  }, [res, isLoading]);

  useEffect(() => {
    getStudentsStat();
  }, [pageNo]);

  const getStudentsStat = () => {
    if (!currentCampus) return;

    setLinkEduStepCode(eduStepCode);

    const gradeStatParam: IPtStatsByStudentsDetailReq = {
      campusCode: currentCampus,
      startDate: startDate,
      endDate: endDate,
      eduStepCode: eduStepCode == '' ? 'EM' : eduStepCode,
      pageNo: pageNo,
      perPage: pageSize,
    };

    execute(getPtStatsByStudentsDetail(gradeStatParam));
  };

  const getCampusName = (campusCode: string) => {
    if (!campusCode) return 'NO CAMPUS';

    const campus = campusData.find((item) => item.campusCode === campusCode);
    return i18n.language === 'ko'
      ? campus?.campusKorName
      : campus?.campusEngName;
  };

  const getColumns = () => {
    let columns: TableColumnsType<IPtStatsByStudentsDetail> = [];

    if (linkEduStepCode === 'MD') {
      columns = [
        {
          title: t('entrance.statistics.column1'),
          dataIndex: 'campusName',
          align: 'center',
        },
        {
          title: t('statistics.placementTest.column7'),
          dataIndex: 'examDate',
          key: 'examDate',
          align: 'center',
        },
        {
          title: t('student.student.column64'),
          dataIndex: 'memberCode',
          key: 'memberCode',
          align: 'center',
        },
        {
          title: t('student.student.column5'),
          dataIndex: 'memberName',
          align: 'center',
        },
        {
          title: t('student.student.column2'),
          dataIndex: 'schoolName',
          align: 'center',
        },
        {
          title: t('entrance.statistics.column2'),
          dataIndex: 'gradeCode',
          align: 'center',
          render: (value) => getCommonCodeLabel('SY0006', value, 'ko'),
        },
        {
          title: 'Prediger',
          align: 'center',
          children: [
            {
              title: t('common.column.status'), //상태
              dataIndex: 'predigerRequiredYn',
              align: 'center',
              render: (value, record) => {
                if (value === 'Y') {
                  if (record.predigerCompleteYn === 'Y') {
                    // return t('entrance.schedule.text3');
                    return t('entrance.schedule.text5');
                  } else {
                    return t('entrance.schedule.text9');
                    // return t('entrance.schedule.text4');
                  }
                } else {
                  return t('entrance.schedule.text10');
                }
              },
            },
          ],
        },
        {
          title: 'Placement Test',
          align: 'center',
          children: [
            {
              title: t('cbt.type.column8'), //유형
              dataIndex: 'placeTestName',
              align: 'center',
              render: (value, record) => {
                if (record.placeTestCompleteYn == 'Y') {
                  return value?.replace('중등 Placement Test ', '');
                } else {
                  return '';
                }
              },
            },
            {
              title: t('common.column.status'), //상태
              dataIndex: 'placeTestName',
              align: 'center',
              render: (value, record) => {
                if (record.placeTestCompleteYn == 'Y') {
                  return t('entrance.schedule.text5');
                } else {
                  return t('entrance.schedule.text4');
                }
              },
            },
            {
              title: 'Overall',
              //   dataIndex: 'overall',
              align: 'center',
              render: (value, record) => {
                if (record.placeTestCompleteYn == 'Y') {
                  return record.placeTestScore;
                } else {
                  return '';
                }
              },
            },
            {
              title: 'L',
              dataIndex: 'platListeningScore',
              align: 'center',
            },
            {
              title: 'P',
              dataIndex: 'platPhonicsScore',
              align: 'center',
            },
            {
              title: 'R',
              dataIndex: 'platReadingScore',
              align: 'center',
            },

            {
              title: 'V',
              dataIndex: 'platVocaScore',
              align: 'center',
            },

            {
              title: 'G',
              dataIndex: 'platGrammerScore',
              align: 'center',
            },
          ],
        },

        {
          title: 'Writing Test',
          children: [
            {
              title: 'Type',
              align: 'center',
              dataIndex: 'writingType',
              render: (value, record) => {
                if (record.writingParagraph !== null) {
                  return 'P.W';
                } else if (record.writingEssay !== null) {
                  return 'E.W';
                } else {
                  return '';
                }
              },
            },
            {
              title: 'Score',
              align: 'center',
              dataIndex: 'writingScore',
              render: (value, record) => {
                if (record.writingParagraph !== null) {
                  return record.writingParagraph;
                } else if (record.writingEssay !== null) {
                  return record.writingEssay;
                } else {
                  return '';
                }
              },
            },
          ],
        },
        {
          title: t('statistics.platstudents.column2'),
          dataIndex: 'recommandCourseName',
          align: 'center',
        },
        {
          title: t('statistics.platstudents.column3'),
          dataIndex: 'regCourseName',
          align: 'center',
        },
        {
          title: t('statistics.platstudents.column4'),
          dataIndex: 'regClassName',
          align: 'center',
        },
        //
        {
          title: t('student.student.column35'), //상담자
          dataIndex: 'counselorName',
          align: 'center',
        },
        //
      ];
    } else {
      columns = [
        {
          title: t('entrance.statistics.column1'),
          dataIndex: 'campusName',
          align: 'center',
        },
        {
          title: t('statistics.placementTest.column7'),
          dataIndex: 'examDate',
          key: 'examDate',
          align: 'center',
        },
        {
          title: t('student.student.column64'),
          dataIndex: 'memberCode',
          key: 'memberCode',
          align: 'center',
        },
        {
          title: t('student.student.column5'),
          dataIndex: 'memberName',
          align: 'center',
        },
        {
          title: t('student.student.column2'),
          dataIndex: 'schoolName',
          align: 'center',
        },
        {
          title: t('entrance.statistics.column2'),
          dataIndex: 'gradeCode',
          align: 'center',
          render: (value) => getCommonCodeLabel('SY0006', value, 'ko'),
        },
        {
          title: 'OCEAN',
          //   dataIndex: 'oceanRequiredYn',
          align: 'center',
          children: [
            {
              title: t('common.column.status'), //상태
              dataIndex: 'oceanRequiredYn',
              align: 'center',
              render: (value, record) => {
                if (value === 'Y') {
                  if (record.oceanCompleteYn === 'Y') {
                    return t('entrance.schedule.text3');
                  } else {
                    return t('entrance.schedule.text4');
                  }
                } else {
                  return t('entrance.schedule.text10');
                }
              },
            },
          ],
        },
        {
          title: 'Pre Test',
          dataIndex: 'preRequiredYn',
          align: 'center',

          children: [
            {
              title: t('cbt.type.column8'), //유형
              dataIndex: 'preRequiredYn',
              align: 'center',
              render: (value, record) => {
                if (value === 'Y') {
                  if (record.preTestCompleteYn === 'Y') {
                    return t('entrance.schedule.text5');
                  } else {
                    return t('entrance.schedule.text4');
                  }
                } else {
                  return t('entrance.schedule.text10');
                }
              },
            },
            {
              title: t('common.column.status'), //상태
              dataIndex: 'preRequiredYn',
              align: 'center',
              render: (value, record) => {
                if (value === 'Y') {
                  if (record.preTestCompleteYn === 'Y') {
                    return record.preTestName?.replace('Pre Test ', '');
                  } else {
                    return '';
                  }
                } else {
                  return t('entrance.schedule.text10');
                }
              },
            },
            {
              title: 'Score',
              dataIndex: 'preRequiredYn',
              align: 'center',
              render: (value, record) => {
                if (value === 'Y') {
                  if (record.preTestCompleteYn === 'Y') {
                    return record.preTestScore;
                  } else {
                    return '';
                  }
                } else {
                  return '';
                }
              },
            },
          ],
        },
        {
          title: 'Placement Test',
          align: 'center',
          dataIndex: 'placeTestName',
          children: [
            {
              title: t('cbt.type.column8'), //유형
              dataIndex: 'placeTestName',
              align: 'center',
              render: (value, record) => {
                if (record.placeTestCompleteYn == 'Y') {
                  return value?.replace('Placement Test ', '');
                } else {
                  return '';
                }
              },
            },
            {
              title: t('common.column.status'), //상태
              dataIndex: 'placeTestName',
              align: 'center',
              render: (value, record) => {
                if (record.placeTestCompleteYn == 'Y') {
                  return t('entrance.schedule.text5');
                } else {
                  return t('entrance.schedule.text4');
                }
              },
            },
            {
              title: 'Overall',
              //   dataIndex: 'overall',
              align: 'center',
              render: (value, record) => {
                if (record.placeTestCompleteYn == 'Y') {
                  return record.placeTestScore;
                } else {
                  return '';
                }
              },
            },

            {
              title: 'L',
              dataIndex: 'platListeningScore',
              align: 'center',
            },
            {
              title: 'P',
              dataIndex: 'platPhonicsScore',
              align: 'center',
            },
            {
              title: 'R',
              dataIndex: 'platReadingScore',
              align: 'center',
            },

            {
              title: 'V',
              dataIndex: 'platVocaScore',
              align: 'center',
            },

            {
              title: 'G',
              dataIndex: 'platGrammerScore',
              align: 'center',
            },
          ],
        },

        {
          title: 'Speaking Test',
          children: [
            {
              title: 'Part1',
              dataIndex: 'speakingPart1',
              align: 'center',
            },
            {
              title: 'Part2',
              dataIndex: 'speakingPart2',
              align: 'center',
            },
          ],
        },
        {
          title: t('statistics.platstudents.column2'),
          dataIndex: 'recommandCourseName',
          align: 'center',
        },
        {
          title: t('statistics.platstudents.column3'),
          dataIndex: 'regCourseName',
          align: 'center',
        },
        {
          title: t('statistics.platstudents.column4'),
          dataIndex: 'regClassName',
          align: 'center',
        },
        //
        {
          title: t('student.student.column35'), //상담자
          dataIndex: 'counselorName',
          align: 'center',
        },
        //
      ];
    }

    return columns;
  };

  const onExportTable = () => {
    const gradeStatParam: IPtStatsByStudentsDetailReq = {
      campusCode: currentCampus,
      startDate: startDate,
      endDate: endDate,
      eduStepCode: eduStepCode == '' ? 'EM' : eduStepCode,
      pageNo: pageNo,
      perPage: 999999999,
    };

    setExcelCampus(currentCampus);

    execute2(getPtStatsByStudentsDetail(gradeStatParam));
  };

  useEffect(() => {
    if (res2?.data && !isLoading2) {
      const _data: IPtStatsByStudentsDetail[] = _.cloneDeep(res2.data);
      _data.forEach((item) => {
        //학년
        item.gradeCode = getCommonCodeLabel('SY0006', item.gradeCode, 'ko');

        if (linkEduStepCode === 'MD') {
          //Prediger
          if (item.predigerRequiredYn === 'Y') {
            if (item.predigerCompleteYn === 'Y') {
              item.predigerRequiredYn = t('entrance.schedule.text3');
            } else {
              item.predigerRequiredYn = t('entrance.schedule.text4');
            }
          } else {
            item.predigerRequiredYn = t('entrance.schedule.text10');
          }

          //시험타입
          if (item.placeTestCompleteYn == 'Y') {
            item.placeTestName =
              item.placeTestName?.replace('중등 Placement Test ', '') +
              ' ' +
              t('entrance.schedule.text5') +
              '(' +
              item.placeTestScore +
              ')';
          } else {
            item.placeTestName = t('entrance.schedule.text4');
          }

          //Writing Type
          if (item.writingParagraph !== null) {
            item.writingType = 'P.W';
          } else if (item.writingEssay !== null) {
            item.writingType = 'E.W';
          } else {
            item.writingType = '';
          }

          //Writing Score
          if (item.writingParagraph !== null) {
            item.writingScore = item.writingParagraph;
          } else if (item.writingEssay !== null) {
            item.writingScore = item.writingEssay;
          } else {
            item.writingType = '';
          }
        } else {
          //ocean-Test
          if (item.oceanRequiredYn === 'Y') {
            if (item.oceanCompleteYn === 'Y') {
              item.oceanRequiredYn = t('entrance.schedule.text3');
            } else {
              item.oceanRequiredYn = t('entrance.schedule.text4');
            }
          } else {
            item.oceanRequiredYn = t('entrance.schedule.text10');
          }

          //pre-Test
          if (item.preRequiredYn === 'Y') {
            if (item.preTestCompleteYn === 'Y') {
              item.preRequiredYn =
                t('entrance.schedule.text5') +
                '(' +
                item.preTestName?.replace('Pre Test ', '') +
                '/' +
                item.preTestScore +
                ')';
            } else {
              item.preRequiredYn = t('entrance.schedule.text4');
            }
          } else {
            item.preRequiredYn = t('entrance.schedule.text10');
          }

          //시험타입
          if (item.placeTestCompleteYn == 'Y') {
            item.placeTestName =
              item.placeTestName?.replace('Placement Test ', '') +
              ' ' +
              t('entrance.schedule.text5') +
              '(' +
              item.placeTestScore +
              ')';
          } else {
            item.placeTestName = t('entrance.schedule.text4');
          }
        }
      });
      const currentDate = moment(new Date());
      let excelSize: number[] = [];
      if (linkEduStepCode === 'MD') {
        excelSize = [
          12, 10, 15, 15, 15, 10, 10, 15, 10, 10, 10, 10, 10, 10, 10, 10, 10,
          10, 15,
        ];
      } else {
        excelSize = [
          12, 10, 15, 15, 15, 10, 10, 15, 15, 10, 10, 10, 10, 10, 10, 10, 10,
          10, 10, 20,
        ];
      }

      exportTable(
        getColumns(),
        _data,
        `${t('statistics.placementTest.title1')}_${t(
          'entrance.schedule.tab3',
        )}_${getCampusName(excelCampus)}_(${currentDate.format('YYYYMMDD')})`,
        t('entrance.schedule.tab3'),
        excelSize,
      );
    }
  }, [res2, isLoading2]);

  return (
    <>
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>
              <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
              <div>
                <SelectCampus />
              </div>
            </li>
            <li>
              <label>{t('common.placeholder.1')}</label>
              <SelectEduStep
                eduStepCode={eduStepCode}
                setEduStepCode={setEduStepCode}
                includeAll={false}
                width={90}
              />
            </li>
            <li>
              <label>{t('sms.list.column1')}</label> {/* 기간 */}
              <div className="date-picker__area">
                <DatePicker
                  value={startDate ? moment(startDate) : undefined}
                  onChange={(e) => {
                    if (e === null) setStartDate('');
                    else setStartDate(moment(e).format('YYYYMMDD'));
                  }}
                  format={['YYYY-MM-DD', 'YYYYMMDD']}
                />
              </div>
              ~
              <div className="date-picker__area">
                <DatePicker
                  value={endDate ? moment(endDate) : undefined}
                  onChange={(e) => {
                    if (e === null) setEndDate('');
                    else setEndDate(moment(e).format('YYYYMMDD'));
                  }}
                  format={['YYYY-MM-DD', 'YYYYMMDD']}
                />
              </div>
              <div className="comm-btn__area">
                <Button
                  className="btn-basic small black"
                  onClick={onSearch}
                  text={t('common.button.search')}
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
      {isLoading ? <Loader /> : null}
      {<ErrorResponse error={error} />}
      <div>
        <div className="comm-bx__space right">
          {linkEduStepCode === 'EM' ? (
            <div
              style={{
                textAlign: 'right',
                marginRight: '10px',
                marginTop: '5px',
                cursor: 'pointer',
              }}
            >
              <div
                onClick={onSpeakingNote}
                style={{
                  width: '25px',
                  height: '25px',
                  display: 'inline-block',
                  background: '#fff',
                  boxShadow: '1px 1px 3px rgba(0,0,0,.3)',
                  border: '1px solid rgba(0,0,0,.3)',
                  borderRadius: '30px',
                  padding: '2px 0',
                  fontSize: '15px',
                  textAlign: 'center',
                }}
              >
                ❔
              </div>
            </div>
          ) : null}
        </div>
        <div className="comm-table__area">
          <Table
            columns={getColumns()}
            dataSource={data}
            pagination={{
              current: pageNo,
              pageSize: pageSize,
            }}
            rowClassName="pointer"
            rowKey="platRequireCode"
          />
        </div>
        <div className="comm-bx__between">
          <DownloadButton onClick={onExportTable} />
          <div className="common-paging center">
            <Pagination
              count={res?.total || 0}
              page={pageNo}
              setPage={setPageNo}
              perPage={pageSize}
            />
          </div>
        </div>

        {speakingModalVisible && (
          <PtStatsByNotesModal
            visible={speakingModalVisible}
            setVisible={setSpeakingModalVisible}
          />
        )}
      </div>
    </>
  );
};

export default PtStatsByStudentsDetail;
